import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["current", "phases", "voltage", "result"];

  connect() {
    this.calculate();
  }

  calculate() {
    const current = parseFloat(this.currentTarget.value) || 0;
    const phases = parseFloat(this.phasesTarget.value) || 0;
    const voltage = parseFloat(this.voltageTarget.value) || 0;
    const fuseLimit = (current * phases * voltage) / 1000;

    if (fuseLimit <= 0) {
      this.resultTarget.textContent = "—";
      return;
    }

    this.resultTarget.textContent = fuseLimit.toFixed(1);
  }
}
